import { Input, Space } from "antd";

function Searchbar({ onChange }) {
  const { Search } = Input;

  return (
    <div>
      <Space style={{ marginBottom: "20px" }}>
        <Search
          placeholder="Search for a ticket"
          onChange={onChange}
          enterButton
        />
      </Space>
    </div>
  );
}

export default Searchbar;
